export default __webpack_public_path__ + "static/media/avatar14-mujer.fc3ca1b1.png";